<form class="sidenav-content" cdkScrollable *ngIf="!submitting; else spinner">
	<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()" [titleHeaderText]="'issue.register'|translate">
		<button type="button" mat-flat-button
			*ngIf="claim.isDraft"
			(click)="saveAsDraft($event)" [disabled]="isBatchesLoading">
			<span translate>issue.save.as.drafts</span>
			<mat-icon iconPositionEnd class="save-icon" svgIcon="action_save"></mat-icon>
		</button>
		<button type="submit" mat-flat-button color="primary"
				(click)="goToSummary($event)" [disabled]="isBatchesLoading">
			<span translate>issue.select.batches.action.next</span>
		</button>
	</copo-panel-header>
	<div class="copo-stepper-container copo-form-container">
		<copo-stepper [steps]="steps" (stepClicked)="onStepClicked($event)"></copo-stepper>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column copo-margin">
				<div class="copo-label" id="issue-type-label" translate>issue.type.of.request</div>
				<mat-radio-group
					aria-labelledby="issue-type-label"
					class="copo-claim-radio-group"
					[disabled]="disabled"
					[value]="claim.type"
					labelPosition="before"
					(change)="typeChanged($event.value)">
					<mat-radio-button class="copo-claim-radio" value="issue">
						<span translate>claim.quality.issue</span>
					</mat-radio-button>
					<mat-radio-button class="copo-claim-radio" value="warning">
						<span translate>claim.warning</span>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div class="copo-grid-row-column">
				<mat-form-field>
					<mat-label translate>issue.customer.reference</mat-label>
					<input
						type="text"
						matInput
						spellcheck="false"
						autocomplete="off"
						maxlength="20"
						[formControl]="referenceFormControl"
						(change)="referenceChanged($event)">
					<button
						type="button"
						*ngIf="!disabled && referenceFormControl.value"
						matSuffix mat-icon-button
						(click)="claim.reference = ''; referenceFormControl.reset('')"
						tabindex="-1">
						<mat-icon svgIcon="md:close" class="copo-small-close"></mat-icon>
					</button>
				</mat-form-field>
			</div>
			<div class="copo-grid-row-column" *ngIf="claim.type === 'issue'">
				<mat-form-field>
					<mat-label translate>claim.claimtype.label</mat-label>
					<mat-select
						[formControl]="claimTypeFormControl"
						(selectionChange)="claimTypeChanged($event.value)"
						[disabled]="disabled">
						<mat-option value="ZL"><span translate>claim.type.zl</span></mat-option>
						<mat-option value="ZR"><span translate>claim.type.zr</span></mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column defect-copo-grid-row-column" #defectDiv>
				<mat-form-field class="defect-mat-form-field">
					<mat-label translate>issue.defect.type</mat-label>
					<mat-select
						(selectionChange)="defectTypeChanged($event)"
						[formControl]="defectFormControl"
						required>
						<mat-option *ngFor="let defect of defectOptionsValues" [value]="defect.key">{{ defect.value.label | translate }}</mat-option>
					</mat-select>
					<mat-error *ngIf="defectFormControl.hasError('required')"><span translate>claim.defect.mandatory</span></mat-error>
				</mat-form-field>
			</div>
			<div class="copo-grid-row-column copo-margin" *ngIf="claim.defectDetailedRef !== '' && defectOptions[claim.defectDetailedRef]!.sample">
				<div class="copo-label" id="sending-sample-label" translate>issue.sending.sample</div>
				<mat-radio-group
					aria-labelledby="sending-sample-label"
					class="copo-claim-radio-group"
					[formControl]="sendSampleFormControl"
					labelPosition="before"
					(change)="sendingSampleChanged()">
					<mat-radio-button class="copo-claim-radio" value="yes">
						<span translate>global.yes</span>
					</mat-radio-button>
					<mat-radio-button checked class="copo-claim-radio" value="no">
						<span translate>global.no</span>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div class="copo-grid-row-column">
				<div *ngIf="claim.defectDetailedRef === '' || !defectOptions[claim.defectDetailedRef]!.sample" translate>claim.no.sample.needed</div>
			</div>
		</div>
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<div *ngIf="claim.defectDetailedRef !== '' && defectOptions[claim.defectDetailedRef]!.sample && sendSampleFormControl.value === 'yes'" #sampleDiv>
					<mat-form-field>
						<mat-label translate>issue.contact.type</mat-label>
						<mat-select
							[formControl]="contactTypeFormControl"
							(selectionChange)="contactTypeChanged($event)">
							<mat-option
								value="cts"
								[disabled]="disabled">
								<span translate>claim.sample.cts</span>
							</mat-option>
							<mat-option
								value="agency"
								[disabled]="disabled">
								<span translate>claim.sample.agency</span>
							</mat-option>
							<mat-option
								value="other"
								[disabled]="disabled">
								<span translate>claim.sample.other</span>
							</mat-option>
						</mat-select>
						<mat-error *ngIf="contactTypeFormControl.hasError('required')">
							<span translate>claim.contact.type.mandatory</span>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<div class="copo-grid-row-column"
				*ngIf="claim.sampleTr === 'other' && claim.defectDetailedRef !== '' && defectOptions[claim.defectDetailedRef]!.sample && sendSampleFormControl.value === 'yes'">
				<mat-form-field>
					<mat-label translate>issue.contact.info</mat-label>
					<input (change)="sampleCommentChanged($event)" [formControl]="contactInfoFormControl" matInput type="text">
				</mat-form-field>
			</div>
		</div>

		<div class="copo-grid-row copo-grid-row-stretch">
			<div class="copo-grid-row-2-columns">
				<div class="copo-label copo-outline-label" translate>claim.attach.several.documents<span *ngIf="claim.type !== 'warning'" class="asterick">*</span></div>
				<copo-file-upload
					class="file-upload"
					#attachmentDiv
					[files]="files"
					[fileErrors]="fileErrors"
					dragAndDropLabel="Drag and drop"
					orLabel="or"
					browseFilesLabel="Browse files"
					[fileUploadNote]="(claim.claimType === 'ZR' ? 'claim.attachment.limit.zr' : 'claim.attachment.limit.zl') | translate"
					(filesAdded)="addAttachments($event)"
					(fileRemoved)="removeAttachment($event)">
				</copo-file-upload>
			</div>
			<div class="copo-grid-row-2-columns">
				<div class="copo-label copo-outline-label"><span id="comment-label" translate>claim.comment</span> <span class="asterick">*</span></div>
				<mat-form-field #commentDiv class="outline-comment" appearance="outline">
					<textarea rows="3" class="textarea-no-resize" type="textarea"
						maxlength="600"
						cdkTextareaAutosize
						aria-labelledby="comment-label"
						[placeholder]="'claim.comment.placeholder' | translate"
						(change)="commentChanged($event)"
						[formControl]="commentFormControl"
						matInput
						spellcheck="false"
						autocomplete="off">
					</textarea>
					<mat-hint align="end">{{commentFormControl.value.length || 0}}/600</mat-hint>
					<mat-error *ngIf="commentFormControl.hasError('required')"><span translate>claim.comment.mandatory</span>
					</mat-error>
				</mat-form-field>
			</div>
		</div>

		<div class="copo-grid-row additional-cost">
			<div class="copo-grid-row-column">
				<mat-checkbox labelPosition="after"
				[formControl]="haveAdditionalCostFormControl"
				(change)="additionalCostChanged($event.checked)">
					<span class="checkbox-label-wrapped" translate>claim.additional.costs.requested</span>
				</mat-checkbox>
			</div>
		<ng-container *ngIf="haveAdditionalCostFormControl.value === true">
			<div class="copo-grid-row-column" >
				<mat-form-field class="copo-claim-input" floatLabel="always" #otherCostAmountDiv>
					<mat-label translate>claim.other.amount.cost</mat-label>
					<input
						step="any"
						type="number"
						min="0"
						matInput
						spellcheck="false"
						autocomplete="off"
						(change)="otherCostAmountChanged($event)"
						[formControl]="otherCostAmountFormControl">
					<span matTextSuffix>&nbsp;{{ claim.amountUnitTr | uppercase}}</span>
					<mat-error *ngIf="otherCostAmountFormControl.hasError('required')"><span translate>claim.additional.costs.mandatory</span></mat-error>
					<mat-error *ngIf="otherCostAmountFormControl.value && otherCostAmountFormControl.value < 0"><span translate>claim.additional.costs.invalid</span></mat-error>
					<button
						type="button"
						*ngIf="!disabled && otherCostAmountFormControl.value"
						matSuffix
						mat-icon-button
						(click)="claim.otherCostAmount = 0; otherCostAmountFormControl.reset(null)"
						tabindex="-1">
						<mat-icon svgIcon="md:close" class="copo-small-close"></mat-icon>
					</button>
				</mat-form-field>
			</div>
		</ng-container>
	</div>
	<ng-container *ngIf="claim.claimType === 'ZR' && batchesFormArray.controls.length > 0">
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<div class="zr-attachment-info" translate>claim.zr.attachment.info</div>
			</div>
		</div>
		<div class="copo-grid-row zr-cost-row">
			<div class="copo-grid-row-column copo-margin">
				<mat-form-field floatLabel="always" class="selected-batch-impacted-quantity" subscriptSizing="dynamic">
					<mat-label translate>claim.impacted.quantity</mat-label>
					<input
						step="any"
						type="number"
						min="1"
						matInput
						spellcheck="false"
						autocomplete="off"
						(change)="onBatchQuantityChange(claim.batches[0], batchesFormArray.controls[0].controls.claimedQuantity)"
						[formControl]="batchesFormArray.controls[0].controls.claimedQuantity">
					<span matTextSuffix>&nbsp;{{ unitBatchOptions['to'].symbol }}</span>
					<mat-icon matSuffix class="input-edit-icon" color="accent" svgIcon="copo_pencil"></mat-icon>
					<mat-error *ngIf="batchesFormArray.controls[0].controls.claimedQuantity.hasError('required')">
						<span translate>claim.impacted.quantity.mandatory</span>
					</mat-error>
					<mat-error *ngIf="batchesFormArray.controls[0].controls.claimedQuantity.hasError('min')">
						<span translate>claim.impacted.quantity.minimum</span>
					</mat-error>
				</mat-form-field>
			</div>
			<div class="copo-grid-row-column copo-margin">
				<mat-form-field class="copo-claim-input" floatLabel="always" subscriptSizing="dynamic">
					<mat-label translate>claim.material.costs</mat-label>
					<input
						step="any"
						type="number"
						min="0"
						matInput
						spellcheck="false"
						autocomplete="off"
						(change)="materialCostsChanged($event)"
						[formControl]="materialCostsFormControl">
					<span matTextSuffix>&nbsp;{{ claim.amountUnitTr | uppercase}}</span>
					<button
						type="button"
						*ngIf="!disabled && materialCostsFormControl.value"
						matSuffix
						mat-icon-button
						(click)="claim.amountValue = 0; materialCostsFormControl.reset(null)"
						tabindex="-1">
						<mat-icon svgIcon="md:close" class="copo-small-close"></mat-icon>
					</button>
				</mat-form-field>
			</div>
		</div>
	</ng-container>
	<div class="copo-grid-row">
		<div class="copo-grid-row-column copo-margin">
			<div class="copo-label" id="issue-contact-label" translate>issue.contact.label</div>
			<mat-radio-group
				aria-labelledby="issue-contact-label"
				class="copo-claim-radio-group"
				labelPosition="before"
				(change)="visitChanged($event)"
				[value]="claim.wantVisit ? 'yes' : 'no'">
				<mat-radio-button class="copo-claim-radio" value="yes">
					<span translate>global.yes</span>
				</mat-radio-button>
				<mat-radio-button class="copo-claim-radio" value="no">
					<span translate>global.no</span>
				</mat-radio-button>
			</mat-radio-group>
		</div>
	</div>
</div>

	<div class="select-batch-container" *ngIf="mainClaimBatch !== undefined">
		<div class="select-batch-text">
			<span translate>quality.first.selected.batch</span>
			&ngsp;
			<span>
				{{ mainClaimBatch.customerOrderNumber ? mainClaimBatch.customerOrderNumber : UNDERSCORE }}/{{ mainClaimBatch.customerOrderItemNumber ? mainClaimBatch.customerOrderItemNumber : UNDERSCORE }}
				({{(count ?? 0) + 1}} batches)
			</span>
		</div>
	</div>
	<div class="add-main-batch-btn" *ngIf="mainClaimBatch === undefined" #mainBatchDiv>
		<div class="copo-max-width" *ngIf="onErrorMandatory.batchRef">
			<span class="text-error-form" translate>claim.batch.reference.mandatory</span>
		</div>
	</div>
	<div class="main-batch-content" *ngIf="mainClaimBatch !== undefined">
		<div class="main-batch-quality-info-label" translate>quality.information</div>
		<div class="batch-steelgrade">
			<div class="main-batch-info-label" translate>issue.batch.steelgrade</div>
			<div>{{ mainClaimBatch.steelgradeDescription ? mainClaimBatch.steelgradeDescription :
				UNDERSCORE }}</div>
		</div>
		<div class="batch-dimension">
			<div class="main-batch-info-label" translate>issue.batch.dimension</div>
			<div>{{ mainClaimBatch | copoDimension }}</div>
		</div>
		<div class="batch-cdd">
			<div class="main-batch-info-label" translate>issue.batch.cdd</div>
			<div>{{ mainClaimBatch.cddWeek ? mainClaimBatch.cddWeek : UNDERSCORE }}</div>
		</div>
		<div class="batch-mill-description">
			<mat-icon class="main-batch-mill-icon" svgIcon="at_consignment"></mat-icon>
			<span>{{ mainClaimBatch.millDescription }}</span>
		</div>
		<ng-container *ngIf="claim.claimType === 'ZR'">
			<div class="batch-customer-order">
				<div class="main-batch-info-label" translate>issue.batch.customer.order.number</div>
				<div>{{ mainClaimBatch.customerOrderNumber ? mainClaimBatch.customerOrderNumber : UNDERSCORE }}/{{ mainClaimBatch.customerOrderItemNumber ? mainClaimBatch.customerOrderItemNumber : UNDERSCORE }}</div>
			</div>
			<div class="batch-reference">
				<div class="main-batch-info-label" translate>issue.batch.number</div>
				<div>{{ mainClaimBatch.batchReference ? mainClaimBatch.batchReference : UNDERSCORE }}</div>
			</div>
		</ng-container>
		<div class="total-impacted-quantity" *ngIf="claim.claimType !== 'ZR'">
			<div class="total-impacted-quantity-value-color">{{ claim.quantityValue |copoNumber:'weight':(unitBatchOptions['to'].symbol )}}</div>
			<div class="main-batch-info-label" translate>claim.impacted.quantity</div>
		</div>
	</div>

	<ng-container *ngIf="claim.claimType !== 'ZR'">
	<div class="max-select-batch-text" translate>quality.max.selected.batch
		<div class="invoiced-only-filter">
			<copo-slide-button
				class="justify-center"
				labelAfter="filter.all"
				labelBefore="issue.invoiced.batch"
				[checked]="togglePos"
				(toggleChange)="settogglePos($event)">
			</copo-slide-button>
		</div>
		<mat-form-field class="select-batch-search quick-search" appearance="outline" subscriptSizing="dynamic">
			<input [placeholder]="'issue.batch.quick.search'|translate" matInput type="text" spellcheck="false"
				autocomplete="off" [formControl]="searchTextControl" />
			<button type="button" *ngIf="searchTextControl.value" mat-icon-button
				(click)="searchTextControl.reset('');" tabindex="-1" matSuffix>
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
			<mat-icon svgIcon="search" class="quick-search-icon" *ngIf="!searchTextControl.value" matSuffix>
			</mat-icon>
		</mat-form-field>
	</div>
	<div class="pill-row" *ngIf="!isBatchesLoading; else loading" #batchesDiv>
		<div role="group" aria-labelledby="main-batch-ref main-batch-qty" [class.pill-multi-batches]="mainBatch.reference !== ''" [class.pill-default-batches]="mainBatch.reference === ''">
			<ng-container *ngIf="mainBatch.reference !== ''">
				<div class="selected-batch-row">
					<mat-icon class="selected-batch-icon" svgIcon="icon-batch"></mat-icon>
					<div class="selected-batch-number" id="main-batch-ref">
						<div translate>issue.batch.number</div>
						<div>{{mainBatch.reference}}</div>
					</div>
				</div>
				<div class="selected-batch-quantity-row">
					<div class="selected-batch-weight-column" id="main-batch-qty">
						<div class="selected-batch-label" translate>claim.total.weight</div>
						<div>{{quantity(mainBatch)}}</div>
					</div>
					<div class="selected-batch-full">
						<div class="selected-batch-label" id="main-batch-full-quantity-label" translate>claim.full.quantity</div>
						<mat-checkbox
							aria-labelledby="main-batch-full-quantity-label"
							(change)="onFullQuantityCheckboxChange(0)"
							[formControl]="batchesFormArray.controls[0].controls.fullQuantity">
						</mat-checkbox>
					</div>
				</div>
				<mat-form-field floatLabel="always" class="selected-batch-impacted-quantity" subscriptSizing="dynamic">
					<mat-label translate>claim.impacted.quantity</mat-label>
					<input
						#batchQuantity
						step="any"
						type="number"
						min="0"
						matInput
						spellcheck="false"
						autocomplete="off"
						(change)="onBatchQuantityChange(mainBatch, batchesFormArray.controls[0].controls.claimedQuantity)"
						[formControl]="batchesFormArray.controls[0].controls.claimedQuantity">
					<mat-icon matSuffix class="input-edit-icon" color="accent" svgIcon="copo_pencil"></mat-icon>
					<mat-error *ngIf="batchesFormArray.controls[0].controls.claimedQuantity.hasError('required')">
						<span translate>claim.impacted.quantity.mandatory</span>
					</mat-error>
					<mat-error *ngIf="batchesFormArray.controls[0].controls.claimedQuantity.hasError('max')">
						<span translate>claim.quantity.limit.error</span>
					</mat-error>
				</mat-form-field>
				<mat-form-field *ngIf="isNonPrimeOrder" class="rec_date" floatLabel="always">
					<mat-label translate>claim-batch.receipt-date</mat-label>
					<input matInput spellcheck="false" autocomplete="off" readonly
						[copoDatepicker]="startDatepicker" [copoFormat]="formatType"
						(click)="startDatepicker.open()" #startDateInput (focus)="startDateInput.blur()"
						[min]="currentDate" [formControl]="batchesFormArray.controls[0].controls.receiptDate">
					<mat-datepicker-toggle matSuffix class="copo-orange-text-icon" [for]="startDatepicker">
					</mat-datepicker-toggle>
					<mat-datepicker #startDatepicker [startAt]="currentDate">
					</mat-datepicker>
					<mat-error *ngIf="batchesFormArray.controls[0].controls.receiptDate.hasError('required')">
						<span translate>claim.receipt.date.mandatory</span>
					</mat-error>
				</mat-form-field>
			</ng-container>
			<span *ngIf="mainBatch.reference === ''" translate>claim.batch&nbsp;<span
					class="text">1</span></span>
		</div>

		<div role="group" [attr.aria-labelledby]="'selected-batch-ref-' + i + ' selected-batch-qty-' + i" [class.pill-multi-batches]="batch !== null" [class.pill-default-batches]="batch === null"
			*ngFor="let batch of selectedBatches; let i = index ;" >
			<ng-container *ngIf="batch !== null">
				<div class="selected-batch-row">
					<mat-icon class="selected-batch-icon" svgIcon="icon-batch"></mat-icon>
					<div class="selected-batch-number" [id]="'selected-batch-ref-' + i">
						<div translate>issue.batch.number</div>
						<div>{{batch.reference}}</div>
					</div>
				</div>
				<div class="selected-batch-quantity-row">
					<div class="selected-batch-weight-column" [id]="'selected-batch-qty-' + i">
						<div class="selected-batch-label" translate>claim.total.weight</div>
						<div>{{quantity(batch)}}</div>
					</div>
					<div class="selected-batch-full">
						<div class="selected-batch-label" [id]="'selected-batch-full-quantity-label-' + i" translate>claim.full.quantity</div>
						<mat-checkbox
							[aria-labelledby]="'selected-batch-full-quantity-label-' + i"
							(change)="onFullQuantityCheckboxChange(i+1)"
							[formControl]="batchesFormArray.controls[i+1].controls.fullQuantity">
						</mat-checkbox>
					</div>
				</div>
				<mat-form-field floatLabel="always" class="selected-batch-impacted-quantity" subscriptSizing="dynamic">
					<mat-label translate>claim.impacted.quantity</mat-label>
					<input
						#batchQuantity
						step="any"
						type="number"
						min="0"
						matInput
						spellcheck="false"
						autocomplete="off"
						(change)="onBatchQuantityChange(batch, batchesFormArray.controls[i+1].controls.claimedQuantity)"
						[formControl]="batchesFormArray.controls[i+1].controls.claimedQuantity">
					<mat-icon matSuffix class="input-edit-icon" color="accent" svgIcon="copo_pencil"></mat-icon>
					<mat-error *ngIf="batchesFormArray.controls[i+1].controls.claimedQuantity.hasError('required')">
						<span translate>claim.impacted.quantity.mandatory</span>
					</mat-error>
					<mat-error *ngIf="batchesFormArray.controls[i+1].controls.claimedQuantity.hasError('max')">
						<span translate>claim.quantity.limit.error</span>
					</mat-error>
				</mat-form-field>
				<mat-form-field *ngIf="isNonPrimeOrder" floatLabel="always">
					<mat-label translate>claim-batch.receipt-date</mat-label>
					<input matInput spellcheck="false" autocomplete="off" readonly
						[copoDatepicker]="startDatepicker" [copoFormat]="formatType"
						(click)="startDatepicker.open()" #startDateInput (focus)="startDateInput.blur()"
						[min]="currentDate" [formControl]="batchesFormArray.controls[i+1].controls.receiptDate">
					<mat-datepicker-toggle matSuffix class="copo-orange-text-icon" [for]="startDatepicker">
					</mat-datepicker-toggle>
					<mat-datepicker #startDatepicker [startAt]="currentDate">
					</mat-datepicker>
					<mat-error *ngIf="batchesFormArray.controls[i+1].controls.receiptDate.hasError('required')">
						<span translate>claim.receipt.date.mandatory</span>
					</mat-error>
				</mat-form-field>
			</ng-container>
			<span *ngIf="batch === null" translate>claim.batch&nbsp;<span
					class="text">{{i+2}}</span></span>
		</div>
	</div>
	<ng-template #loading>
		<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
	</ng-template>

	<div *ngIf="!isBatchesLoading" class="related-batch-list" copoVirtualScroller [dataId]="dataId" [scrollOnChange]="false" #scroller="copoVirtualScroller"
		(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
		<div class="related-batch" *ngFor="let batch of scroller.list; let i = index" role="group" [attr.aria-labelledby]="'related-batch-ref-' + i + ' related-batch-qty-' + i">
			<mat-checkbox
				[checked]="isChecked(batch)"
				[aria-labelledby]="'related-batch-ref-' + i + ' related-batch-qty-' + i"
				(change)="selectBatches(batch, $event)"
				[disabled]="isDisabled(batch)"></mat-checkbox>
			<div class="related-batch-block">
				<mat-icon class="related-batch-icon" svgIcon="icon-batch"></mat-icon>
				<div class="related-batch-number" [id]="'related-batch-ref-' + i">
					<div translate>issue.batch.number</div>
					<div>{{batch.batchReference}}</div>
				</div>
				<div class="related-batch-status">
					<div translate>batch.invoice.date</div>
					<div>{{batch.invoiceDate}}</div>
				</div>
				<a mat-button color="primary" class="related-batch-documents-link"
					[routerLink]="['/order-tracking/batch/card', batch.id]" fragment="documents">
					<span translate>issue.batch.commercial.documents</span>
					<mat-icon iconPositionEnd class="related-batch-documents-link-icon" color="accent" svgIcon="table_document">
					</mat-icon>
				</a>
				<div class="related-batch-quantity">
					<span class="related-batch-quantity-pill" [id]="'related-batch-qty-' + i">{{ batch.qtyInvoiced | copoNumber:'weight':(unitBatchOptions[lowerCaseUnit(batch.weightUnitInvoiced)] ? unitBatchOptions[lowerCaseUnit(batch.weightUnitInvoiced)].symbol : lowerCaseUnit(batch.weightUnitInvoiced)) }}</span>
				</div>
				<div class="batch-invoiced-icon">
					<ng-container *ngIf="batch.batchInvoiced === 'X'">
						<mat-icon [matTooltip]="'issue.batch.invoiced' | translate" color="accent"
						svgIcon="invoice"></mat-icon>
					</ng-container>
				</div>
				<a class="related-batch-view-details-link" mat-button color="primary"
					[routerLink]="['/order-tracking/batch/card', batch.id]">
					<span translate>issue.batch.view-details</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
				</a>
			</div>
		</div>
		<copo-loading-spinner class="grid-column-one-full" *ngIf="scroller.loading"></copo-loading-spinner>
	</div>
	</ng-container>
</form>
<ng-template #spinner>
	<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
</ng-template>